import styled from 'styled-components';
import { lightGrey2Color, blueColor } from 'js/config/style';

export default styled.div`
  display: grid;
  grid-template-columns: 100%;
  align-content: center;
  justify-content: center;
  cursor: pointer;

  && {
    .pencil {
      fill: ${lightGrey2Color};
    }

    &:hover .pencil {
      fill: ${blueColor};
    }
  }
`;
